import type { ReactNode } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

/**
 * One filter row: label column + control column on `sm+`, stacked on narrow screens.
 * Matches Daily Logs filter card symmetry.
 */
export function FieldOpsFilterRow({
  label,
  htmlFor,
  children,
}: {
  label: string;
  htmlFor?: string;
  children: ReactNode;
}) {
  return (
    <div className="grid grid-cols-1 gap-1 sm:grid-cols-[6.5rem_1fr] sm:gap-x-3 sm:items-center">
      <Label htmlFor={htmlFor} className="text-sm shrink-0 leading-tight">
        {label}
      </Label>
      <div className="min-w-0">{children}</div>
    </div>
  );
}

/** Checkbox row aligned with filter rows (spacer on `sm+` where the label column is). */
export function FieldOpsFilterCheckboxRow({
  id,
  checked,
  onCheckedChange,
  labelText,
}: {
  id: string;
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  labelText: string;
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[6.5rem_1fr] sm:gap-x-3 sm:items-center">
      <span className="hidden sm:block" aria-hidden />
      <div className="flex items-center gap-2 min-h-[44px] sm:min-h-0 sm:py-0.5">
        <Checkbox id={id} checked={checked} onCheckedChange={(v) => onCheckedChange(v === true)} />
        <Label htmlFor={id} className="text-sm font-normal cursor-pointer leading-none">
          {labelText}
        </Label>
      </div>
    </div>
  );
}
